import clsx from 'clsx';
import { useTranslations } from 'next-intl';

import RichText from '@/components/UI/RichText';

interface EventPageDescriptionSectionProps {
  description?: string;
  className?: string;
}

export default function EventPageDescriptionSection({
  description,
  className = '',
}: EventPageDescriptionSectionProps) {
  const t = useTranslations('Pages.Event.EventPageDescriptionSection');

  if (!description) return null;
  return (
    <section className={clsx('pb-16 text-white-filled-default', className)}>
      <h3 className='my-6 text-xl font-extrabold capitalize'>{t('title')}</h3>
      <RichText text={description} />
    </section>
  );
}
